import { render, staticRenderFns } from "./localChainList.vue?vue&type=template&id=3620e2b4&"
import script from "./localChainList.vue?vue&type=script&lang=js&"
export * from "./localChainList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports